import { useCallback, useContext, useState } from "react";
import GlobalContext from "../../context/GlobalContext";
import DataTableComponent from "./DataTableComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import swal from "../../services/swalConfig";
import { deleteHoliday, fetchHolidays } from "../../api/HolidayApi";
import { deleteLocation, fetchLocations } from "../../api/LocationsApi";
import QRDownloadButton from "../button/QrDownloadButton";
import CopyText from "../utilities/CopyText";
import ModalLocation from "../modal/ModalLocation";

import { tr } from "../../i18n";
const TableLocations = ({ refresh }) => {
  const { user, setLoading } = useContext(GlobalContext);
  const [reload, setReload] = useState(0);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);

  const fetchData = useCallback(
    async ({ page, perPage, search }) => {
      if (!user?.workspace?.company_id) return { data: [], total: 0 }; // Hindari request jika company_id belum tersedia

      const response = await fetchLocations({
        companyId: user.workspace.company_id,
        page,
        perPage,
        search,
      });

      const numberedData = response.data.map((item, index) => ({
        ...item,
        no: (page - 1) * perPage + index + 1,
      }));

      return { data: numberedData, total: response.total };
    },
    [user, reload, refresh] // Tambahkan dependency agar berubah saat user berubah
  );

  const handleEdit = (data) => {
    navigate(`/holiday/form?edit=${data.id}`, { state: data });
  };

  const handleDelete = async (id) => {
    const result = await swal.fire({
      title: tr("shared:are_you_sure"),
      text: tr("attendance:you_want_to_delete_this_location"),
      icon: "warning",
      showCancelButton: false,
      confirmButtonText: tr("shared:i_understand_delete"),
      confirmButtonColor: "#f10f29ff",
      cancelButtonText: tr("common:actions.cancel"),
      timer: false,
    });

    if (result.isConfirmed) {
      processDelete(id);
    }
  };

  const processDelete = async (id) => {
    try {
      setLoading(true);

      const data = {
        company_id: user.workspace.company_id,
        coordinate_id: id,
      };

      const response = await deleteLocation(data);

      if (response.status == 200) {
        swal.fire({
          title: tr("shared:success"),
          text: response.message,
          icon: "success",
          showCancelButton: false,
        });

        setReload((prev) => prev + 1);
      } else {
        swal.fire({
          title: tr("common:errors.oops"),
          text: response.message,
          icon: "error",
          showCancelButton: false,
        });
      }
    } catch (error) {
      swal.fire({
        title: tr("common:errors.oops"),
        text: tr("common:errors.generic"),
        icon: "error",
        showCancelButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { name: tr("shared:no"), selector: (row) => row.no, width: "70px", sortable: true },
    {
      name: tr("attendance:map_id"),
      cell: (row) => <CopyText text={row.coordinate_id} />,
      sortable: true,
      wrap: true,
      width: "15%",
    },
    {
      name: tr("shared:name"),
      selector: (row) => row.coordinate_name,
      sortable: true,
      wrap: true,
    },
    {
      name: tr("shared:actions"),
      center: true,
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <QRDownloadButton
            qrUrl={row.barcode_encode}
            fileName={`${row.coordinate_name
              .toLowerCase()
              .replace(/\s+/g, "_")}_qr.png`}
            fillText="Map QR for attendance by GPS"
          />
          <button
            onClick={() => {
              console.log(row);
              setEditData(row);
              setShowModal(true);
            }}
            className="btn btn-primary btn-sm"
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" /> {" "}{tr("common:breadcrumb.edit")}
          </button>
          <button
            onClick={() => handleDelete(row.coordinate_id)}
            className="btn btn-danger btn-sm"
          >
            <FontAwesomeIcon icon={faTrash} className="me-1" /> {" "}{tr("common:actions.delete")}
          </button>
        </div>
      ),
      width: "40%",
      style: {
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      },
    },
  ];

  return (
    <div>
      <DataTableComponent columns={columns} fetchData={fetchData} />
      <ModalLocation
        show={showModal}
        handleClose={() => {
          setShowModal(false);
          setEditData(null);
        }}
        onSuccess={() => setReload((prev) => prev + 1)}
        data={editData}
      />
    </div>
  );
};

export default TableLocations;
